import { EventName } from '@lit/react';
import { BlocksSearchForm } from 'blocks-nextjs/blocks-web-components/components/search-form/search-form';
import {
  BlocksChangeEvent,
  BlocksCloseEvent,
  BlocksMobileOverlayCloseEvent,
  BlocksMobileOverlayOpenEvent,
  BlocksOpenEvent,
  BlocksScrollEndEvent,
  BlocksSearchEvent,
  BlocksSelectEvent
} from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatSearchForm = createComponent({
  react: React,
  tagName: 'cat-search-form',
  elementClass: BlocksSearchForm,
  events: {
    onBlChange: 'bl-change' as EventName<BlocksChangeEvent>,
    onBlSelect: 'bl-select' as EventName<BlocksSelectEvent>,
    onBlMobileOverlayClose: 'bl-mobile-overlay-close' as EventName<BlocksMobileOverlayCloseEvent>,
    onBlMobileOverlayOpen: 'bl-mobile-overlay-open' as EventName<BlocksMobileOverlayOpenEvent>,
    onBlSearch: 'bl-search' as EventName<BlocksSearchEvent>,
    onBlSearchClose: 'bl-search-close' as EventName<BlocksCloseEvent>,
    onBlSearchOpen: 'bl-search-open' as EventName<BlocksOpenEvent>,
    onBlScrollEnd: 'bl-scroll-end' as EventName<BlocksScrollEndEvent>
  }
});
